import { graphql } from '@/gql'

export const TypeRefFragmentDef = graphql(`
  fragment TypeRef on __Type {
    kind
    name
    ofType {
      kind
      name
      ofType {
        kind
        name
        ofType {
          kind
          name
          ofType {
            kind
            name
            ofType {
              kind
              name
              ofType {
                kind
                name
                ofType {
                  kind
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`)

export const InputValueFragmentDef = graphql(`
  fragment InputValue on __InputValue {
    name
    description
    type {
      ...TypeRef
    }
    defaultValue
  }
`)

export const FieldTypeFragmentDef = graphql(`
  fragment FieldType on __Field {
    name
    description
    args {
      ...InputValue
    }
    type {
      ...TypeRef
    }
    isDeprecated
    deprecationReason
  }
`)

export const FullTypeFragmentDef = graphql(`
  fragment FullType on __Type {
    kind
    name
    description
    fields(includeDeprecated: true) {
      ...FieldType
    }
    inputFields {
      ...InputValue
    }
    interfaces {
      ...TypeRef
    }
    enumValues(includeDeprecated: true) {
      name
      description
      isDeprecated
      deprecationReason
    }
    possibleTypes {
      ...TypeRef
    }
  }
`)

export const IntrospectionQuery = graphql(`
  query Introspection {
    __schema {
      queryType {
        ...FullType
      }
      types {
        ...FullType
      }
    }
  }
`)

export const CompanyFragmentDef = graphql(`
  fragment CompanyAccount on Company {
    id
    name
    avatar
    avatarPath @client
  }
`)

export const OrganisationFragmentDef = graphql(`
  fragment OrganisationAccount on Organisation {
    id
    name
    avatar
    divisions(page: 1, first: 10000) {
      data {
        ...CompanyAccount
      }
    }
  }
`)

export const CompanyOrganisationsFragmentDef = graphql(`
  fragment CompanyOrganisationsAccount on Company {
    organisations(first: 1000, page: 1) {
      data {
        ...OrganisationAccount
      }
    }
  }
`)

export const CompanyAccountsQuery = graphql(`
  query CompanyAccounts {
    accounts {
      id
      name
      avatar
      ... on Company {
        ...CompanyAccount
        ...CompanyOrganisationsAccount
      }
      ... on Organisation {
        ...OrganisationAccount
      }
    }
  }
`)
